import React, {useContext, useState} from 'react';
import ReactDOM from 'react-dom';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonButtons, IonButton, IonMenuButton, IonModal, IonLabel } from '@ionic/react';


import '../../css/layout.css';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

export function ProfileSetting_PaymentInfo (props) {

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);



    return (
        <React.Fragment>            
        {props.openModal == true ?
        (

            <IonModal className='appModal' isOpen={ props.openModal }>
                    <IonItem>
                        <IonLabel>Company Name: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Bank Account First Name: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Bank Account Last Name: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Company Phone Number: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Bank Name: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Bank Account Number: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Bank Routing Number: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Bank Branch Location: </IonLabel>
                        <IonButton> Update </IonButton>
                    </IonItem>
                    <IonButton>
                            Save
                    </IonButton>

                    <IonButton onClick={() => props.closeModal()}> Close </IonButton>

            </IonModal>
                    
            ) : null }
            </React.Fragment>

    );
};


